import { Injectable } from "@angular/core";

import { TranslateService } from "@ngx-translate/core";

import { Store } from "@ngrx/store";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { from } from "rxjs";
import { AppState } from "../../reducers";
import {
  switchMap,
  map,
  catchError,
  exhaustMap,
  mergeMap,
} from "rxjs/operators";
import { SnackbarType } from "src/app/models/snackbar/snackbar.model";

import * as PosCardsActionTypes from "../../actions/pos-cards/pos-cards.actions";
import * as MessagesActionTypes from "../../actions/messages/message.actions";
import { PosCardsService } from "src/app/shared/services/pos-cards/poscards.service";
import { TableConfigService } from "src/app/shared/services/table-config/table-config.service";
import { SnackBarUtils } from "src/app/shared/utils/snackbarUtils";
@Injectable()
export class PosCardsEffects {
  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private postCardService: PosCardsService,
    private tableConfigService: TableConfigService,
    private translate: TranslateService
  ) {}

  getPosCards$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PosCardsActionTypes.getPosCards),
      switchMap((action) =>
        this.postCardService
          .getPosCards(
            action.options.paging,
            action.options.filteringArgs,
            action.options.sortingArgs,
            action.options.advancedFilteringArgs
          )
          .pipe(
            map((result) => {
              return PosCardsActionTypes.loadPosCards({ response: result });
            }),
            catchError((error) => {
              const actions = [PosCardsActionTypes.setLoadingEndState()];

              return from(actions);
            })
          )
      )
    )
  );
  getExcelPosCards$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PosCardsActionTypes.getExcelPosCards),
      switchMap((action) =>
        this.postCardService
          .getPosCards(
            action.options.paging,
            action.options.filteringArgs,
            action.options.sortingArgs,
            action.options.advancedFilteringArgs
          )
          .pipe(
            map((result) =>
              PosCardsActionTypes.loadExcelPosCards({ response: result })
            ),
            catchError((error) => {
              const actions = [PosCardsActionTypes.setLoadingEndState()];

              return from(actions);
            })
          )
      )
    )
  );

  getPosCard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PosCardsActionTypes.getPosCard),
      switchMap((action) =>
        this.postCardService.getPosCard(action.code).pipe(
          map((result) =>
            PosCardsActionTypes.loadPosCard({ response: result })
          ),
          catchError((error) => {
            const actions = [PosCardsActionTypes.setLoadingEndState()];
            return from(actions);
          })
        )
      )
    )
  );
  getPosCardTableConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PosCardsActionTypes.getPosCardsTableConfig),
      exhaustMap((action) =>
        this.tableConfigService
          .getConfigSettings(action.options.code, action.options.settingType)
          .pipe(
            map((result) =>
              PosCardsActionTypes.loadPosCardsTableConfig({
                response: result,
              })
            ),
            catchError((error) => {
              const actions = [
                PosCardsActionTypes.loadPosCardsTableConfig({
                  response: [],
                }),
              ];
              return from(actions);
            })
          )
      )
    )
  );

  savePosCardTableConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PosCardsActionTypes.savePosCardsTableConfig),
      exhaustMap((action) =>
        this.tableConfigService.saveConfigSettings(action.config).pipe(
          mergeMap(() => [
            PosCardsActionTypes.setLoadingEndState(),
            MessagesActionTypes.setSnackbar(
              SnackBarUtils.setSnackBar(
                this.translate.instant("TableConfig.SaveSuccess"),
                SnackbarType.SUCCESS
              )
            ),
          ]),
          catchError((error: any) => {
            const actions = [
              PosCardsActionTypes.setLoadingEndState(),
              MessagesActionTypes.setSnackbar(
                SnackBarUtils.setSnackBar(
                  this.translate.instant("TableConfig.SaveError"),
                  SnackbarType.ERROR
                )
              ),
            ];
            return from(actions);
          })
        )
      )
    )
  );
}
